import Link from 'next/link';
import { forwardRef } from 'react';

import { NextLinkComposedProps } from 'components/@common/Link/types';

const LinkUnstyled = forwardRef<HTMLAnchorElement, NextLinkComposedProps>(
  (props, ref) => <Link {...props} ref={ref} />,
);

LinkUnstyled.displayName = 'LinkUnstyled';

export default LinkUnstyled;
